import React from 'react';
import { isObservable } from 'mobx';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { Tag } from 'legacyComponents/styled/lib';
import { media } from 'legacyComponents/styled/styleUtils';

import { RowStyle, OnlyRowStyle } from 'apps/repository/styles';

import { Icon } from 'components';

@observer
export class ReturnRow extends React.Component {
  dragOver = () => {
    const { dragState, params } = this.props;
    if (!dragState) return;
    const routeParams = isObservable(params) ? params.toJS() : params;
    const parentDir = { file: { path: routeParams.basepath, isFolder: true } };
    dragState.DragOver(parentDir);
  };

  render() {
    const { route, params, onlyRow, content } = this.props;
    const Component = onlyRow ? OnlyRowStyle : RowStyle;

    const routeName = route.endsWith('project') ? `${route}.files` : route;

    // FIXME - remove those props form <Tag> for now
    // onDragOver={this.dragOver} highlighted={highlighted}
    return (
      <Component height='40px'>
        <Link name={routeName} params={params} content={content}>
          <ReturnTag>
            <Icon name='arrow_left' size='xsmall' />
          </ReturnTag>
        </Link>
      </Component>
    );
  }
}

const ReturnTag = styled(Tag)`
  margin-top: 4px;
  margin-left: 30px;
  width: 30px;
  height: 30px;
  padding-left: 9px;
  padding-top: 6px;
  ${media.m`
    margin-left: 15px;
  `};
`;

ReturnRow.propTypes = {
  route: PropTypes.string,
  params: PropTypes.object,
  onlyRow: PropTypes.bool,
  content: PropTypes.object,
  dragState: PropTypes.object,
};
